import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AddGovernanceUserRoleRequest } from '@interfaces/GovernanceUnit';

@Injectable({ providedIn: 'root' })
export class GovernanceUnitApi {
  constructor(private http: HttpClient) {}

  getUnits(): Observable<any> {
    return this.http.get('/governance-unit');
  }

  addGovernanceUnitUsers(userRoleInfo: AddGovernanceUserRoleRequest): Observable<void> {
    return this.http.post<void>('/governance-unit/user', userRoleInfo);
  }
}
